// Maps a backend error `code` to panel-owned ES copy. Anything unrecognized (or a network failure
// without a code) fails OPEN to the generic message. We never render the envelope's
// `message`/`detail` (untrusted backend string).
// No `persistent` flag any more: every failure is reported through the floating notice, which stays
// up until the agent dismisses it (ADR 0021), so «does this one survive a timer» stopped being a
// property of the cause.
const SPECIFIC: Record<string, string> = {
  delivery_box_occupied: 'El buzón ya está ocupado por otra entrega.', // TODO: i18n
  delivery_state_conflict: 'La entrega ha cambiado de estado.', // TODO: i18n
  delivery_already_retrieved: 'El paquete ya fue recuperado por el mensajero.', // TODO: i18n
};

export function enableDeliveryError(code: string | null): string {
  // Own-property only: the code is wire data, and a bare lookup also resolves inherited names, so a
  // `constructor` code came back truthy and pinned a banner with no readable message.
  const key = code?.toLowerCase() ?? '';
  const message = Object.hasOwn(SPECIFIC, key) ? SPECIFIC[key] : undefined;
  return message ?? 'No se pudo restaurar la entrega. Inténtalo de nuevo.'; // TODO: i18n
}
